// extracted by mini-css-extract-plugin
export default {"inner-link":"styles_inner-link__Z5qHT"};